import { apiSlice } from '@/shared/api/apiSlice'
import { ServerResponse } from '@/shared/types/common'
import { TServiceServer } from '@/shared/types/deprecated-types'
import { TAccessories } from '@/shared/types/product-types'

export const productApi = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getProductDescription: builder.query<string, number>({
			query: productId => ({
				url: `/products/${productId}/description`
			}),
			transformResponse: (response: ServerResponse<{ DETAIL_TEXT: string }>) => response.data.DETAIL_TEXT
		}),
		getProductServices: builder.query<TServiceServer, number>({
			query: productId => ({
				url: `/products/${productId}/services`
			}),
			transformResponse: (response: ServerResponse<TServiceServer>) => response.data
		}),
		getProductAccessories: builder.query<TAccessories, number>({
			query: productId => ({
				url: `/products/${productId}/accessories`
			}),
			transformResponse: (response: ServerResponse<TAccessories>) => response.data
		})
	})
})

export const {
	useGetProductDescriptionQuery,
	useGetProductServicesQuery,
	useGetProductAccessoriesQuery,
	useLazyGetProductAccessoriesQuery
} = productApi
